module.exports = __webpack_public_path__ + "static/report/img/w5.9d493a5f.png";